/** 🎮 Face Buttons */
enum MainButton {
  A = 'b0', // Cross / Bottom button
  B = 'b1', // Circle / Right button
  Y = 'b2', // Triangle / Top button
  X = 'b3', // Square / Left button
}

/** 🔼 Directional Pad */
enum DirectionalPadButtons {
  Up = 'b12',
  Down = 'b13',
  Left = 'b14',
  Right = 'b15',
}

/** ⚙️ System / Meta Buttons */
enum SystemButton {
  Back = 'b9', // View / Share / Minus
  Start = 'b8', // Menu / Options / Plus
}

/** 🕹️ Right Stick: Move abstraction + Button click */
enum RightStickInput {
  Move = 'rs',
  Press = 'b11',
}

/** 🕹️ Left Stick: Move abstraction + Button click */
enum LeftStickInput {
  Move = 'ls', // axis movement
  Press = 'b10', // stick click
}

/** 🎯 Shoulder Buttons (digital) + Triggers (analog) */
enum ShoulderButton {
  LB = 'b4',
  RB = 'b5',
  LT = 'b6',
  RT = 'b7',
}

/** 🧾 All Inputs Combined */
export type JoystickInput =
  | MainButton
  | ShoulderButton
  | SystemButton
  | DirectionalPadButtons
  | RightStickInput
  | LeftStickInput;

/** Grouped Access */
export const JoystickInputs = {
  Face: MainButton,
  DPad: DirectionalPadButtons,
  System: SystemButton,
  RightStick: RightStickInput,
  LeftStick: LeftStickInput,
  Shoulder: ShoulderButton,
};

/** 🎯 Axis index mapping for Left/Right sticks */
export const stickAxisMap = {
  [LeftStickInput.Move]: [0, 1],
  [RightStickInput.Move]: [2, 3],
} as const;

export type StickId = keyof typeof stickAxisMap; // "ls" | "rs"

export const JOYSTICK_INPUT_LABEL_MAP: Record<JoystickInput, string> = {
  // 🎮 Face buttons
  [MainButton.A]: 'MainButton.A',
  [MainButton.B]: 'MainButton.B',
  [MainButton.X]: 'MainButton.X',
  [MainButton.Y]: 'MainButton.Y',

  // 🔼 D-Pad
  [DirectionalPadButtons.Up]: 'DirectionalPadButtons.Up',
  [DirectionalPadButtons.Down]: 'DirectionalPadButtons.Down',
  [DirectionalPadButtons.Left]: 'DirectionalPadButtons.Left',
  [DirectionalPadButtons.Right]: 'DirectionalPadButtons.Right',

  // ⚙️ System
  [SystemButton.Back]: 'SystemButton.Back',
  [SystemButton.Start]: 'SystemButton.Start',

  // 🕹️ Sticks
  [LeftStickInput.Move]: 'LeftStickInput.Move',
  [LeftStickInput.Press]: 'LeftStickInput.Press',
  [RightStickInput.Move]: 'RightStickInput.Move',
  [RightStickInput.Press]: 'RightStickInput.Press',

  // 🎯 Shoulder
  [ShoulderButton.LB]: 'ShoulderButton.LB',
  [ShoulderButton.RB]: 'ShoulderButton.RB',
  [ShoulderButton.LT]: 'ShoulderButton.LT',
  [ShoulderButton.RT]: 'ShoulderButton.RT',
};
